import React, { useState, useEffect } from 'react';
import usflag from '../../assets/images/usflag.png';

const NotificationCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDropping, setIsDropping] = useState(false);

  // Random women names
  const womenNames = [
    'Emma', 'Olivia', 'Ava', 'Isabella', 'Sophia', 'Charlotte', 'Mia', 'Amelia',
    'Harper', 'Evelyn', 'Abigail', 'Emily', 'Elizabeth', 'Mila', 'Ella', 'Avery',
    'Sofia', 'Camila', 'Aria', 'Scarlett', 'Victoria', 'Madison', 'Luna', 'Grace',
    'Chloe', 'Penelope', 'Layla', 'Riley', 'Zoey', 'Nora', 'Lily', 'Eleanor',
    'Hannah', 'Lillian', 'Addison', 'Aubrey', 'Ellie', 'Stella', 'Natalie', 'Zoe'
  ];

  // Seasonal analysis values
  const seasonalValues = [
    'Warm Neutral',
    'Cool Neutral',
    'Warm Deep',
    'Cool Deep',
    'Warm Light',
    'Cool Light',
    'Soft Warm',
    'Soft Cool',
    'Rich Warm',
    'Rich Cool'
  ];

  // Generate 20 different notifications
  const generateNotifications = () => {
    const notifications = [];
    for (let i = 0; i < 20; i++) {
      const randomName = womenNames[Math.floor(Math.random() * womenNames.length)];
      const randomSeason = seasonalValues[Math.floor(Math.random() * seasonalValues.length)];
      
      notifications.push({
        id: i,
        name: randomName,
        season: randomSeason
      });
    }
    return notifications;
  };

  const [notifications] = useState(generateNotifications());

  useEffect(() => {
    // Simple interval approach - change item every 5 seconds for testing
    const intervalId = setInterval(() => {
      console.log('Changing item at:', new Date().toLocaleTimeString());
      
      // Trigger slide-up animation
      setIsVisible(false);
      
      // After slide-up, change notification
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % notifications.length);
        setIsDropping(true);
        setIsVisible(true);
        
        // Reset dropping state
        setTimeout(() => {
          setIsDropping(false);
        }, 500);
      }, 300);
    }, 5000); // Fixed 5 seconds for testing

    // Cleanup
    return () => {
      clearInterval(intervalId);
    };
  }, [notifications.length]);

  const currentNotification = notifications[currentIndex];

  return (
    <div className="py-2 w-full overflow-hidden">
      <div className="flex items-center justify-center">
        <div 
          className={`flex items-center transition-all duration-500 ease-in-out ${
            isVisible 
              ? isDropping 
                ? 'opacity-100 transform translate-y-0 animate-bounce' 
                : 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform -translate-y-4'
          }`}
        >
          <div className="text-xs text-[#6B7280] flex items-center font-['Inter',system-ui,-apple-system,sans-serif] whitespace-nowrap">
            <span className="font-semibold text-[#7C3A8D]">{currentNotification.name}</span>
            <span className="mx-1 text-[#6B7280]">Just Bought her Analysis!</span>
            <img 
              src={usflag} 
              alt="US Flag" 
              className="w-4 h-3 mx-1 rounded-sm object-cover shadow-sm"
            />
            <span className="text-[#6B7280] mr-1">She is</span>
            <span className="font-bold text-[#7C3A8D] bg-[#FFE6D1] px-1 py-0.5 rounded text-xs">{currentNotification.season}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCarousel; 